import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="bg-black-deep grain-overlay border-t border-gold/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
        <div className="flex flex-col items-center gap-8">
          {/* Logo */}
          <Link to="/" className="block">
            <img 
              src="https://customer-assets.emergentagent.com/job_luxury-pairing/artifacts/hfw3h7bx_Diamond%20Club%20Footer%20Logo.png"
              alt="Diamond Club Matchmaking"
              className="h-20 md:h-24 w-auto object-contain"
            />
          </Link>
          
          {/* Membership Inquiries */}
          <div className="text-center">
            <p className="font-sans text-xs tracking-widest uppercase text-cream-muted mb-2">
              Membership Inquiries:
            </p>
            <a 
              href="mailto:Jessica@diamondclubmatchmaking.com"
              className="font-sans text-sm text-gold hover:text-gold-light transition-colors duration-300 block"
            >
              Jessica@diamondclubmatchmaking.com
            </a>
            <a 
              href="tel:+17547575054"
              className="font-sans text-sm text-gold hover:text-gold-light transition-colors duration-300 block mt-1"
            >
              754-757-5054
            </a>
          </div>
          
          {/* Footer Links */}
          <div className="flex items-center gap-8">
            <Link
              to="/privacy"
              className="font-sans text-xs tracking-widest uppercase text-cream-muted hover:text-gold transition-colors duration-300"
            >
              Privacy Policy
            </Link>
            <span className="text-gold/30">|</span>
            <Link
              to="/terms"
              className="font-sans text-xs tracking-widest uppercase text-cream-muted hover:text-gold transition-colors duration-300"
            >
              Terms of Service
            </Link>
          </div>
          
          {/* Copyright */}
          <p className="font-sans text-xs text-cream-muted/60 tracking-wide">
            © 2026 Diamond Club Matchmaking. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
